import { authHeader } from './auth-header';
import { apiConfig } from "@/state/helpers";

export const userService = {
    login,
    loginSso,
    logout,
    save,
    update,
    get,
    getAll,
    remove,
    changePassword,
    profile,
    resetPass,
    confirmPass
};

function login(username, password) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${apiConfig.apiUrl}/user/login`, requestOptions)
        .then(handleResponse)
        .then(loadProfile);
}

// Login SSO Azure: kirim authorization code ke backend untuk ditukar dengan token aplikasi
function loginSso(code, nonce) {

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ code, nonce })
    };

    return fetch(`${apiConfig.apiUrl}/user/login/sso`, requestOptions)
        .then(handleResponse)
        .then(loadProfile);
}

function loadProfile(user) {
    return fetch(`${apiConfig.apiUrl}/user/profile`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.data.token
        },
    }).then(handleResponse).then(response => {
        if (response.data.role.name == 'admin' || response.data.role.name == 'superadmin') {
            user.data.userdata = response.data;
            localStorage.setItem('user', JSON.stringify(user.data));
            return user.data;
        } else {
            const error = "This account don't have access.";
            return Promise.reject(error);
        }
    });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function save(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiConfig.apiUrl}/user`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function update(payload) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiConfig.apiUrl}/user`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function get(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${apiConfig.apiUrl}/user/${payload}/username`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function getAll(payload) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${apiConfig.apiUrl}/user/all?offset=${payload.offset}&limit=${payload.limit}&search=${payload.search}&role=${payload.role}&area=${payload.area}`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function remove(payload) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiConfig.apiUrl}/user`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function changePassword(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiConfig.apiUrl}/user/changepassword`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function profile() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${apiConfig.apiUrl}/user/profile`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function resetPass(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email }),
    };
    return fetch(`${apiConfig.apiUrl}/user/forgotpassword`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function confirmPass(payload) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    };
    return fetch(`${apiConfig.apiUrl}/user/confirmpassword`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
    });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.info) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
